var exports = {
  "D": "ColorDivider__5haUfi",
};

module.exports = exports;
